import { useContext } from "react";
import { StyledContainer, StyledRightSide } from "../../pages/SignIn/SignIn.styles";
import { ThemeContext } from '../../Contexts/themeContext';
import BaseA3 from './BaseA3'
import BaseOrigino from './BaseOrigino'

const BaseBasicForm = (props) => {
  const { logoTenant } = useContext(ThemeContext);

  const host = window.location.hostname;
  const subdomain = host.split(".")[0];

  let LeftComponent = null;
  switch (subdomain) {
    case 'a3':
      LeftComponent = <BaseA3 />;
      break;
    default:
      LeftComponent = <BaseOrigino props={props} logoTenant={logoTenant} />;
      break;
  }

  return (
    <StyledContainer container spacing={0}>
      {LeftComponent}
      <StyledRightSide item xs={6} className="d-flex flex-column align-center justify-center">
        {props.children}
      </StyledRightSide>
    </StyledContainer>
  );
};

export default BaseBasicForm;
